
import DeviceRoutes from './DeviceRoutes';

export default DeviceRoutes;